module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 137.81ab9047.png";